import React from 'react'
import '../styles.scss'

const QuestionPage = () => {
  window.scrollTo(0, 90)
  return (
    <div className="comming-soon">
      <h2>Frequently asked questions</h2>
      <h6>comming soon</h6>
    </div>
  )
}

export default QuestionPage
